/* CsvImportCancelConfirmModal styles */

:host {
  display: contents;
}

/* ---------- Modal part overrides ----------- */

inmar-hc-modal::part(dialog) {
  align-items: start;
}

inmar-hc-modal::part(content) {
  max-height: none;
}

inmar-hc-modal::part(body) {
  padding: 0;
  overflow: visible;
  flex: none;
}

inmar-hc-modal::part(footer) {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--spacing-6);
  gap: var(--spacing-4);
  border-top: 1px solid var(--color-gray-200);
  margin-inline: calc(-1 * var(--spacing-6));
  margin-block-end: calc(-1 * var(--spacing-6));
}

/* ---------- Body layout ----------- */

.cancel-confirm-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-6);
  gap: var(--spacing-5);
  min-height: 215px;
}

/* ---------- Warning icon ----------- */

.warning-icon {
  --hcds-icon-size: 42px;
  color: var(--color-gray-900);
}

.success-icon {
  --hcds-icon-size: 42px;
  color: var(--color-green-600);
}

/* ---------- Warning message ----------- */

.warning-message {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--text-base);
  font-weight: var(--font-weight-normal);
  color: var(--color-gray-900);
  line-height: var(--leading-snug);
  text-align: center;
  max-width: 311px;
}

/* ---------- Footer layout ----------- */

.cancel-confirm-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-4);
}
